import { MarketerProduct } from '../../../typings/marketers';

export const UPDATE_INTERNAL_MARKETER_PRODUCT = 'UPDATE_INTERNAL_MARKETER_PRODUCT';
export type UPDATE_INTERNAL_MARKETER_PRODUCT = typeof UPDATE_INTERNAL_MARKETER_PRODUCT;

export interface UpdateInternalMarketerProduct {
    type: UPDATE_INTERNAL_MARKETER_PRODUCT;
    product: MarketerProduct;
    isRemoving?: boolean;
    isSaved?: boolean;
}

export function updateInternalMarketerProductAction(
    product: MarketerProduct,
    { isRemoving, isSaved }: Partial<Pick<MarketerProduct, 'isSaved' | 'isRemoving'>>
): UpdateInternalMarketerProduct {
    return {
        type: UPDATE_INTERNAL_MARKETER_PRODUCT,
        product,
        isRemoving,
        isSaved
    };
}
